/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Grow,
} from '@mui/material';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import commaNumber from 'comma-number';
import './SingleFlight.css';
import MoreFlight from './MoreFlight';
import FlightLayout from './FlightLayout';

const SingleFlight = ({
  flightData,
  adultCount,
  childCount,
  infant,
  quotetionArr,
  setQuotetionArr,
}) => {
  const navigate = useNavigate();
  const FlightInformation = (data) => {
    navigate('/user/flightinformation', {
      state: {
        flightData,
        data,
        adultCount,
        childCount,
        infant,
      },
    });
  };

  const [checked, setChecked] = useState(false);
  const handleBox = (data) => {
    const isChecked = !checked; // Use the inverse of the current state
    setChecked(isChecked);

    if (isChecked) {
      setQuotetionArr([...quotetionArr, data]); // Use 'data' instead of 'flightData'
    } else {
      const filteredArr = quotetionArr.filter(
        (item) => item.Carrier !== data.Carrier
      );
      setQuotetionArr(filteredArr);
    }
  };

  const PaxCount = adultCount + childCount + infant;
  let count = [];
  for (let i = 0; i < PaxCount; i++) {
    count.push(i);
  }

  // ----   --------Copy form ALL.js end----------
  return (
    <Box mb={2.5}>
      <Grid
        container
        sx={{
          boxShadow:
            '-0.452679px 4.97947px 36px rgba(0, 0, 0, 0.09), -0.0905357px 0.995893px 5.85px rgba(0, 0, 0, 0.045)',
          borderRadius: '10px',
        }}
      >
        <Grid item sm={12} md={10} lg={10} p={2}>
          {flightData?.AllLegsInfo?.map((data, index, arr) => (
            <Box key={index}>
              <FlightLayout
                checked={checked}
                handleBox={handleBox}
                disabled={false}
                arr={arr}
                flightData={data}
                allData={flightData}
                index={index}
              />
            </Box>
          ))}
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={2}
          lg={2}
          pt={{ xs: 0.5, md: 2 }}
          pb={{ xs: 0.5, md: 2 }}
          pr={2}
          textAlign={{ xs: 'center', md: 'right' }}
          bgcolor="var(--bgcolor)"
          sx={{
            overflow: 'hidden',
            borderTopRightRadius: { xs: '', md: '10px' },
            borderBottomRightRadius: { xs: '', md: '10px' },
          }}
        >
          <Box textAlign="end" mr={{ xs: '5px', md: '0px' }}>
            <Typography
              sx={{
                fontSize: '18px',
                color: 'var(--secondary-color)',
                fontWeight: 500,
                display: { xs: 'none', md: 'block' },
              }}
            >
              <span style={{ fontSize: '13px' }}>AED</span>&nbsp;
              {commaNumber(Math.round(flightData?.NetFare))}
            </Typography>
          </Box>

          <Box
            textAlign="end"
            mt={{ xs: 0, md: 1 }}
            px={{ xs: 2, md: '0' }}
            display={{ xs: 'flex', md: 'block' }}
            justifyContent="space-between"
            alignItems={{ xs: 'center', md: '' }}
          >
            <Button
              size="small"
              sx={{
                color: 'var(--white)',
                fontWeight: 500,
                backgroundColor: 'var(--yello-color)',
                boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                borderRadius: '5px',
                textTransform: 'capitalize',
                '&:hover': {
                  backgroundColor: 'var(--yello-color)',
                },
                padding: { xs: '3px 10px', md: '3px 15px' },
              }}
              onClick={() => FlightInformation(flightData?.AllLegs)}
            >
              Book Now
            </Button>
            <MoreFlight
              flightData={flightData}
              adultCount={adultCount}
              childCount={childCount}
              infant={infant}
              FlightInformation={FlightInformation}
            />
          </Box>
        </Grid>
      </Grid>
      <Box></Box>
    </Box>
  );
};

export default React.memo(SingleFlight);
